import {Pipe, PipeTransform} from '@angular/core';
import {path} from 'app/core/url/app-urls.service';

@Pipe({
    name: 'appUrl',
})
export class AppUrlPipe implements PipeTransform {
    transform(value: string, ...args: any[]): string {
        args = args && !Array.isArray(args) ? [args] : args;
        return path(value, ...(args || []));
    }
}
